// Utility functions for handling file downloads

interface DownloadFileProps {
  blob: Blob; // The zip blob data
  fileCount: number; // Number of files in the zip
  baseName: string; // Base name for the files (e.g., 'masterfile', 'document')
  includeTimestamp?: boolean; // Whether to include timestamp (default: true)
  extension?: string; // The file extension (default: 'zip')
}
export const downloadFile = ({
  blob,
  fileCount,
  baseName,
  includeTimestamp = false,
  extension = 'zip',
}: DownloadFileProps): void => {
  const timestamp = includeTimestamp
    ? `_${new Date().toISOString().split('T')[0]}`
    : '';
  const filename = `${baseName}${fileCount > 1 ? `_${fileCount}_files` : ''}${timestamp}.${extension || 'zip'}`;
  downloadBlob({ blob, filename });
};

interface DownloadBlobProps {
  blob: Blob; // The blob data to download
  filename: string; // The name of the file to download
}
export const downloadBlob = ({ blob, filename }: DownloadBlobProps): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
